import React from 'react'
import SbEditable from "storyblok-react"
import Heading from 'src/components/Heading'

const Testimonial = ({blok}) => {

    return (
        <SbEditable content={blok} key={blok._uid}>
            <div className="bg-white">
                <div className="max-w-7xl mx-auto px-6 my-32 lg:my-56">
                    <p className="font-display font-semibold text-[32px] leading-9 tracking-[-1px] md:text-[40px] md:leading-10 lg:text-5xl text-center max-w-[847px] mx-auto text-darkblue pb-4 ">
                        {blok.content}
                    </p>
                    <div className="mt-6 font-semibold  flex flex-row justify-center items-center gap-4 text-xl tracking-[-0.03em] text-darkblue-700">
                        {blok.person}
                    </div>
                    <div className=" flex flex-row font-semibold justify-center items-center  text-center text-sm tracking-[-0.03em] text-darkblue-700">
                        {blok.position && <> {blok.position}</>} 
                    </div>
                </div>
            </div>
      </SbEditable>
    )
  };

export default Testimonial;
  